<template>
  <div id="marathon_videoSectionCameraIndex" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        @changeSelectEvent="changeSelect"
      ></marathon_select_opt>
    </div>
    <div class="dataList">
      <span class="dataList_item" v-for="item in dataList" :key="item.id">
        <span class="item_main">
          <template v-for="keyItem in dataList_keyArr">
            <span
              class="item_row"
              v-if="
                keyItem.isShowText &&
                (item[keyItem.key] || item[keyItem.key] === 0)
              "
              :key="keyItem.key"
            >
              <span class="item_title" v-text="`${keyItem.name}:`"></span>
              <span
                v-if="keyItem.type !== 'Checkbox'"
                class="item_text"
                v-text="
                  `${
                    keyItem.key === 'timingBlanket'
                      ? computedTimingBlanket(item[keyItem.key])
                      : keyItem.ceil
                      ? item[keyItem.key] + keyItem.ceil
                      : item[keyItem.key]
                  }`
                "
              ></span>
              <span
                v-else
                class="item_text"
                v-text="
                  `${
                    item[keyItem.key] && item[keyItem.key].length > 0
                      ? item[keyItem.key].join('、')
                      : ''
                  }`
                "
              ></span>
            </span>
          </template>
        </span>
        <span class="item_btns">
          <span class="btn" v-text="'编辑'" @click="editItem(item)"></span>
          <span class="btn" v-text="'删除'" @click="delItem(item)"></span>
        </span>
      </span>
      <span class="add_item" @click="clickAddCamera">
        <span class="centerArea">
          <span class="centerArea_icon">
            <i class="el-icon-plus"></i>
          </span>
          <span class="centerArea_title" v-text="'添加摄像机位'"></span>
        </span>
      </span>
    </div>
    <div class="pagination_row">
      <MixtmtPagination
        @CurrentChange="handleCurrentChange"
        @SizeChange="handleSizeChange"
        :pageSizes="pageSizes"
        :pnum="pnum"
        :psize="psize"
        :total="total"
      />
    </div>
    <Popup
      v-if="popupShow"
      :closeEvent="closePopup"
      :popTitle="popTitle"
      :popOpraBtns="popOpraBtns"
      :contentWidth="contentWidth"
    >
      <template #webmaster_popup>
        <!-- 添加|修改机位 -->
        <div
          class="group_popup"
          v-if="popState === 'addCarmera' || popState === 'editCarmera'"
        >
          <div
            class="group_popup_row"
            :class="keyItem.className ? keyItem.className : ''"
            v-for="keyItem in dataList_keyArr"
            :key="keyItem.key"
          >
            <span v-if="keyItem.isRequest" v-text="`*${keyItem.name}`"></span>
            <span v-else v-text="keyItem.name"></span>
            <div class="row_right_item" v-if="keyItem.type === 'String'">
              <el-input
                v-model="addCamerObj[keyItem.key]"
                :placeholder="`请输入${keyItem.name}`"
              ></el-input>
            </div>
            <div class="row_right_item" v-else-if="keyItem.type === 'Select'">
              <el-select
                v-model="addCamerObj[keyItem.key]"
                popper-class="popup_select_opt"
                :popper-append-to-body="false"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in addCamerKmArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div class="row_right_item" v-else-if="keyItem.type === 'Time'">
              <el-input-number
                v-model="addCamerObj[keyItem.key]"
                :precision="1"
              />
              <span class="ceil" v-text="'秒'"></span>
            </div>
            <div
              class="row_right_item flexColumn"
              v-else-if="keyItem.type === 'Checkbox'"
            >
              <el-checkbox
                :indeterminate="checkBoxObj.isIndeterminate"
                v-model="checkBoxObj.checkAll"
                @change="handleCheckAllChange"
              >
                全选
              </el-checkbox>
              <el-checkbox-group
                v-model="checkBoxObj.serviceItems"
                @change="handleCheckedGroupChange"
              >
                <el-checkbox
                  v-for="item in checkBoxObj.serviceItemsArr"
                  :label="item.name"
                  :key="item.id"
                ></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>

          <div class="group_popup_warning" v-show="warningText">
            <span>*</span>
            <span v-text="warningText"></span>
          </div>
        </div>
        <!-- 删除机位 -->
        <div class="group_popup" v-if="popState === 'delCarmera'">
          <div class="group_popup_delete_tit">该机位将从数据库中彻底删除</div>
          <div class="group_popup_delete_wraning">
            您确定删除
            <span
              v-text="
                addCamerObj ? `【${addCamerObj[dataList_keyArr[0].key]}】` : ''
              "
            ></span>
            吗？
          </div>
        </div>
      </template>
    </Popup>
  </div>
</template>

<script>
import {
  https_marathon_stageteammenu,
  https_marathon_liveMonitoringList,
  https_marathon_timingpointsList,
  https_marathon_addCameraItem,
  https_marathon_removeCameraItem,
  https_marathon_updateCameraItem,
} from '@api/platfrom_marathon_api'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import Popup from '@components/base/base_popup.vue'
export default {
  name: 'marathon_videoSectionCameraIndex',
  components: {
    marathon_select_opt,
    Popup,
  },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      loading: false,
      dataList: null,
      dataList_keyArr: [
        {
          name: '摄像机位名称',
          key: 'name',
          isRequest: true,
          isShowText: true,
          type: 'String',
          ceil: '',
        },
        // {
        //   name: '机位代码',
        //   key: 'code',
        //   isRequest: true,
        //   isShowText: false,
        //   type: 'String',
        //   ceil: '',
        // },
        {
          name: '播流地址',
          key: 'streamAddress',
          isRequest: true,
          isShowText: true,
          type: 'String',
          ceil: '',
        },
        {
          name: '推流地址',
          key: 'streamingAddress',
          isRequest: true,
          isShowText: true,
          type: 'String',
          ceil: '',
        },
        {
          name: '计时毯位',
          key: 'timingBlanket',
          isRequest: true,
          isShowText: true,
          type: 'Select',
          ceil: '',
        },
        {
          name: '偏移时间',
          key: 'offsetTime',
          isRequest: true,
          isShowText: true,
          type: 'Time',
          ceil: '秒',
        },
        {
          name: '服务项目',
          key: 'serviceItems',
          isRequest: true,
          isShowText: true,
          type: 'Checkbox',
          ceil: '',
          className: 'alignItemsStart',
        },
      ],
      addCamerKmArr: [
        // {
        //   id: '1',
        //   name: '出发点',
        // },
        // {
        //   id: '2',
        //   name: '5公里',
        // },
        // {
        //   id: '3',
        //   name: '10公里',
        // },
        // {
        //   id: '4',
        //   name: '8公里',
        // },
      ],
      checkBoxObj: {
        checkAll: false,
        serviceItems: [],
        isIndeterminate: false,
        serviceItemsArr: [],
      },
      tableTotal: 0,
      currStageMarathon: '',
      marathonTypeArr: [],
      selectOptData: {
        configArr: [
          {
            type: 'marathonType',
            title: '赛事类型',
            origin_keyVal: ['value', 'name'],
            dataName: 'marathonTypeArr',
          },
        ],
        selectOpt_list: [],
      },
      contentWidth: '56%',
      popupShow: false,
      popTitle: '添加摄像机位',
      popState: '',
      addCamerObj: {},
      popOpraBtns: [],
      warningText: '',
      pnum: 1,
      psize: 6,
      pageSizes: [6, 12, 18],
      total: null,
    }
  },
  created() {
    this.init()
  },
  computed: {
    noMore() {
      const curdataListNum = this.dataList ? this.dataList.length : -1
      return (
        curdataListNum >= this.tableTotal &&
        this.tableTotal !== 0 &&
        this.isScrollBottom
      )
    },
    noData() {
      return (
        this.tableTotal === 0 && this.dataList && this.dataList.length === 0
      )
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      console.debug(this.currCid, this.currSid)
      await this.getTimingpoints()
      await this.getstageMarathon()
      // this.dataList = [
      //   {
      //     id: 1,
      //     name: '出发点',
      //     code: '',
      //     streamAddress:
      //       'rtmp://111583.livepush.myqcloud.com/trtc_1400439699/live_2042479925028144202?txSecret=3a3e34dc176c11011df52f2f6c54fa5a&txTime=63BA55FB',
      //     streamingAddress:
      //       'rtmp://111583.livepush.myqcloud.com/trtc_1400439699/live_2042479925028144202?txSecret=3a3e34dc176c11011df52f2f6c54fa5a&txTime=63BA55FB',
      //     timingBlanket: '5',
      //     offsetTime: 1,
      //     serviceItems: ['全马', '半马'],
      //     nextTime: 1,
      //   },
      //   {
      //     id: 2,
      //     name: '出发点1',
      //     code: '',
      //     streamAddress: 'https://hyper-sports.mixtmt.com/broadcastList/index',
      //     streamingAddress: '',
      //     timingBlanket: '10',
      //     offsetTime: 1,
      //     serviceItems: ['全马', '半马'],
      //     nextTime: 1,
      //   },
      // ]
      console.debug(this.stageArr)
      this.computedSelectOpt(this.selectOptData.configArr)

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        console.debug(config.dataName, this[config.dataName])
        let list = this[config.dataName].map((item) => {
          item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
          return item
        })
        selectOpt_list.push({
          type: config.type,
          title: config.title,
          keyVal: [mix_id, config.origin_keyVal[1]],
          curId: list[0][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
          curVal: list[0][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
          disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
          list,
        })
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'marathonType') {
            this.currStageMarathon = valPathArr[1]
          }
          this.getList()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    computedTimingBlanket(id) {
      let name = ''
      this.addCamerKmArr.forEach((item) => {
        if (id === item.id) {
          name = item.name
        }
      })
      // console.debug('computedTimingBlanket:', name)
      return name
    },
    async getTimingpoints() {
      await https_marathon_timingpointsList(this.axiosBaseUrl, this.$axios)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.addCamerKmArr = res.data
              ? res.data.map((item) => {
                  return {
                    id: item.timingPoint,
                    name: item.pointName,
                  }
                })
              : []
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getstageMarathon() {
      await https_marathon_stageteammenu(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        cid: this.currCid,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.marathonTypeArr = res.data ? res.data : []
            this.currStageMarathon = res.data[0] ? res.data[0].value : ''
            this.checkBoxObj.serviceItemsArr = res.data
              ? res.data.map((item) => {
                  return {
                    id: item.value,
                    name: item.name,
                  }
                })
              : []
            this.getList()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getList() {
      await https_marathon_liveMonitoringList(this.axiosBaseUrl, this.$axios, {
        matchId: this.currSid,
        code: this.currStageMarathon,
        page: this.pnum,
        pageSize: this.psize,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.dataList = res.data.datas
              ? res.data.datas.map((item) => {
                  return {
                    id: item.streamId,
                    name: item.streamName,
                    code: item.raceId,
                    streamAddress: item.streamUrl,
                    streamingAddress: item.publishUrl,
                    timingBlanket: item.pointName
                      ? (() => {
                          let val = ''
                          this.addCamerKmArr.forEach((itemKm) => {
                            // console.debug('itemKm:', itemKm)
                            if (itemKm.name == item.pointName) {
                              val = itemKm.id
                            }
                          })
                          return val
                        })()
                      : '',
                    offsetTime: item.timeOffset,
                    serviceItems: item.projectCodes
                      ? item.projectCodes.split(',').map((id) => {
                          let val = ''
                          this.marathonTypeArr.forEach((itemKm) => {
                            // console.debug('itemKm:', itemKm)
                            if (itemKm.value == id) {
                              val = itemKm.name
                            }
                          })
                          return val
                        })
                      : [],
                  }
                })
              : []
            this.total = res.data.total
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async postAddCameraItem(item) {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await https_marathon_addCameraItem(this.axiosBaseUrl, this.$axios, {
        matchId: this.currSid,
        postData: item,
      })
        .then((response) => {
          const res = response.data
          console.debug(res)
          if (res.status === 0) {
            console.debug('添加成功')
            this.$message({
              showClose: true,
              message: '添加成功',
              type: 'success',
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    handleSizeChange(val) {
      console.debug(`每页 ${val} 条`)
      this.psize = val
      this.pnum = 1
      this.getList()
    },
    handleCurrentChange(val) {
      console.debug(`当前页: ${val}`)
      this.pnum = val
      this.getList()
    },
    handleCheckAllChange(val) {
      console.debug('CheckAll:', val)
      this.checkBoxObj.serviceItems = val
        ? this.checkBoxObj.serviceItemsArr.map((item) => {
            return item.name
          })
        : []
      this.checkBoxObj.isIndeterminate = false
    },
    handleCheckedGroupChange(value) {
      console.debug('CheckedGroup:', value)
      let checkedCount = value.length
      this.checkBoxObj.checkAll =
        checkedCount === this.checkBoxObj.serviceItemsArr.length
      this.checkBoxObj.isIndeterminate =
        checkedCount > 0 &&
        checkedCount < this.checkBoxObj.serviceItemsArr.length
    },
    clickAddCamera() {
      this.initAddCameraPopup()
      this.popOpraBtns = [
        {
          btnTitle: '取消',
          btnEvent: this.closePopup,
          btnStyle: '',
        },
        {
          btnTitle: '保存',
          btnEvent: this.saveSubmit,
          btnStyle: '',
        },
        {
          btnTitle: '保存继续添加',
          btnEvent: this.GoOnsaveSubmit,
          btnStyle: '',
        },
      ]
      this.popState = 'addCarmera'
      this.popTitle = '添加摄像机位'
      this.popupShow = true
    },
    editItem(item) {
      console.debug('editItem:', item)
      let checkBoxObj = this.checkBoxObj
      checkBoxObj.serviceItems = item.serviceItems
      this.checkBoxObj = checkBoxObj
      this.popState = 'editCarmera'
      this.popOpraBtns = [
        {
          btnTitle: '取消',
          btnEvent: this.closePopup,
          btnStyle: '',
        },
        {
          btnTitle: '保存',
          btnEvent: this.editSubmit,
          btnStyle: '',
        },
      ]
      this.popTitle = '编辑摄像机位'
      this.addCamerObj = item
      this.popupShow = true
    },
    delItem(item) {
      this.contentWidth = '40%'
      this.addCamerObj = item
      this.popOpraBtns = [
        {
          btnTitle: '取消',
          btnEvent: this.closePopup,
          btnStyle: '',
        },
        {
          btnTitle: '确定',
          btnEvent: this.removeSubmit,
          btnStyle: '',
        },
      ]
      this.popState = 'delCarmera'
      this.popTitle = '删除摄像机位'
      this.popupShow = true
    },
    // 关闭弹窗
    closePopup() {
      this.popupShow = false
      this.addCamerObj = {}
      this.warningText = ''
      this.contentWidth = '56%'
    },
    initAddCameraPopup() {
      // 初始化添加摄像机位对象
      let addCamerObj = {}
      let checkBoxObj = this.checkBoxObj
      checkBoxObj.serviceItems = []
      checkBoxObj.checkAll = false
      checkBoxObj.isIndeterminate = false
      this.checkBoxObj = checkBoxObj
      this.checkBoxObj.serviceItems = []
      this.dataList_keyArr.forEach((key) => {
        console.debug(key)
        if (key.type === 'String' || key.type === 'Select') {
          addCamerObj[key.key] = ''
        } else if (key.type === 'Time') {
          addCamerObj[key.key] = 0
        } else if (key.type === 'Checkbox') {
          addCamerObj[key.key] = []
        }
      })
      this.addCamerObj = addCamerObj
      this.warningText = ''
    },
    async removeSubmit() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await https_marathon_removeCameraItem(this.axiosBaseUrl, this.$axios, {
        matchId: this.currSid,
        streamId: this.addCamerObj.id,
      })
        .then((response) => {
          const res = response.data
          console.debug(res)
          if (res.status === 0) {
            console.debug('删除成功')
            this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success',
            })
            this.closePopup()
            this.getList()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async GoOnsaveSubmit() {
      await this.saveSubmit('goOn')
    },

    async editSubmit(isGoOn) {
      console.debug(this.addCamerObj)
      if (this.checkBoxObj.serviceItems.length > 0) {
        this.addCamerObj.serviceItems = this.checkBoxObj.serviceItems
      } else {
        this.addCamerObj.serviceItems = null
      }

      if (!this.root_isTrue(this.addCamerObj.name)) {
        this.warningText = '请输入机位名称'
        return
      }
      if (!this.root_isTrue(this.addCamerObj.streamAddress)) {
        this.warningText = '请输入播流地址'
        return
      }
      if (!this.root_isTrue(this.addCamerObj.streamingAddress)) {
        this.warningText = '请输入推流地址'
        return
      }
      if (!this.root_isTrue(this.addCamerObj.timingBlanket)) {
        this.warningText = '请选择计时毯'
        return
      }
      if (typeof this.addCamerObj.offsetTime !== 'number') {
        this.warningText = '请输入偏移量'
        return
      }
      if (!this.root_isTrue(this.addCamerObj.serviceItems)) {
        this.warningText = '请选择服务项目'
        return
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await https_marathon_updateCameraItem(this.axiosBaseUrl, this.$axios, {
        matchId: this.currSid,
        streamId: this.addCamerObj.id,
        postData: {
          streamName: this.addCamerObj.name,
          streamUrl: this.addCamerObj.streamAddress,
          publishUrl: this.addCamerObj.streamingAddress,
          timingPoint: this.addCamerObj.timingBlanket,
          timeOffset: this.addCamerObj.offsetTime,
          projectCodes: this.addCamerObj.serviceItems
            .map((item) => {
              let value = ''
              this.marathonTypeArr.forEach((typeItem) => {
                if (typeItem.name === item) {
                  value = typeItem.value
                }
              })
              return value
            })
            .join(','),
        },
      })
        .then((data) => {
          if (data) {
            this.$message({
              showClose: true,
              message: '修改成功',
              type: 'success',
            })
            console.debug(isGoOn)
            if (isGoOn === 'goOn') {
              this.initAddCameraPopup()
            } else {
              this.closePopup()
            }
            this.getList()
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async saveSubmit(isGoOn) {
      console.debug(this.addCamerObj)
      if (this.checkBoxObj.serviceItems.length > 0) {
        this.addCamerObj.serviceItems = this.checkBoxObj.serviceItems
      } else {
        this.addCamerObj.serviceItems = null
      }

      if (!this.root_isTrue(this.addCamerObj.name)) {
        this.warningText = '请输入机位名称'
        return
      }
      if (!this.root_isTrue(this.addCamerObj.streamAddress)) {
        this.warningText = '请输入播流地址'
        return
      }
      if (!this.root_isTrue(this.addCamerObj.streamingAddress)) {
        this.warningText = '请输入推流地址'
        return
      }
      if (!this.root_isTrue(this.addCamerObj.timingBlanket)) {
        this.warningText = '请选择计时毯'
        return
      }
      if (typeof this.addCamerObj.offsetTime !== 'number') {
        this.warningText = '请输入偏移量'
        return
      }
      if (!this.root_isTrue(this.addCamerObj.serviceItems)) {
        this.warningText = '请选择服务项目'
        return
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await https_marathon_addCameraItem(this.axiosBaseUrl, this.$axios, {
        matchId: this.currSid,
        postData: {
          streamName: this.addCamerObj.name,
          streamUrl: this.addCamerObj.streamAddress,
          publishUrl: this.addCamerObj.streamingAddress,
          timingPoint: this.addCamerObj.timingBlanket,
          timeOffset: this.addCamerObj.offsetTime,
          projectCodes: this.addCamerObj.serviceItems
            .map((item) => {
              let value = ''
              this.marathonTypeArr.forEach((typeItem) => {
                if (typeItem.name === item) {
                  value = typeItem.value
                }
              })
              return value
            })
            .join(','),
        },
      })
        .then((data) => {
          // console.debug(data)
          if (data) {
            this.$message({
              showClose: true,
              message: '添加成功',
              type: 'success',
            })
            console.debug(isGoOn)
            if (isGoOn === 'goOn') {
              this.initAddCameraPopup()
            } else {
              this.closePopup()
            }
            this.getList()
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
  },
}
</script>

<style lang="scss" scoped>
#marathon_videoSectionCameraIndex {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }

  .dataList {
    padding: 2.778vw 0;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    align-content: flex-start;
    .add_item,
    .dataList_item {
      margin: 0 1.74vw 1.743vw 0;
      width: 25.69vw;
      height: 22.5vw;
      background-color: var(--mixtmt_greyColor8);
      border-radius: 0.556vw;
      &:nth-child(3n) {
        margin: 0 0 1.743vw 0;
      }
    }
    .add_item {
      position: relative;
      & .centerArea {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 10;
        width: 100%;
        padding: 10%;
        transform: translate(-50%, -50%);
        display: flex;
        display: -webkit-flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        color: var(--mixtmt_greyColor2);
        .centerArea_icon {
          font-size: 3.472vw;
        }
        .centerArea_title {
          font-size: 1.11vw;
          line-height: 3.472vw;
        }
      }
    }
    .dataList_item {
      position: relative;
      padding-top: 3.472vw;
      border: 1px solid var(--mixtmt_greyColor7);
      .item_main {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-direction: column;
        padding: 1.388vw;
        width: 100%;
        height: 100%;
        background-color: var(--mixtmt_whiteColor);
        border-radius: 0 0 0.556vw 0.556vw;
        .item_row {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: flex-start;
          .item_title,
          .item_text {
            font-size: 0.972vw;
            color: var(--mixtmt_greyColor2);
          }
          .item_title {
            white-space: nowrap;
          }
          .item_text {
            flex: 1;
            padding-left: 0.694vw;
            word-break: break-all;
          }
        }
      }
      .item_btns {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 3.472vw;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        align-items: center;
        .btn {
          margin-right: 1.388vw;
          width: 6.94vw;
          height: 1.94vw;
          border: none;
          border-radius: 0.138vw;
          font-size: 0.833vw;
          font-weight: 500;
          line-height: 1.94vw;
          text-align: center;
          background: var(--mixtmt_whiteColor);
          border: 1px solid var(--mixtmt_greyColor7);
          color: var(--mixtmt_greyColor2);
        }
      }
    }
  }

  .pagination_row {
    padding-bottom: 6.964vw;
    width: 100%;
    text-align: right;
  }

  .loadingClass,
  .noMoreClass,
  .noDataClass {
    position: absolute;
    bottom: -4.166vw;
    left: 0;
    z-index: 2;
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
  .group_popup {
    height: 100%;
    padding: 0.694vw;
    width: 90%;
    h1 {
      font-size: 1.25vw;
      color: var(--mixtmt_greyColor3);
    }
    .group_popup_row {
      margin-bottom: 1.388vw;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      &.alignItemsStart {
        align-items: flex-start;
      }
      .row_right_item {
        flex: 1;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        &.flexColumn {
          flex-direction: column;
          align-items: flex-start;
        }
        .ceil {
          padding-left: 0.694vw;
          font-size: 0.972vw;
          font-weight: 600;
          color: var(--mixtmt_greyColor2);
        }
      }
      & > span {
        width: 8.333vw;
        padding-right: 0.694vw;
        text-align: right;
        font-size: 0.972vw;
        font-weight: 600;
        color: var(--mixtmt_greyColor2);
      }
    }
    .group_popup_warning {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 1.25vw;
      font-size: 0.8333vw;
      font-weight: 400;
      color: var(--mixtmt_errColor);
      line-height: 1.25vw;
      margin: 0.694vw 0;
    }
    .group_popup_btns {
      text-align: center;
      &:after {
        content: '';
        clear: both;
      }
    }
    .group_popup_cancel,
    .group_popup_save {
      display: inline-block;
      width: 8.333vw;
      height: 1.94vw;
      background: rgba(255, 255, 255, 1);
      border-radius: 0.138vw;
      border: 1px solid rgba(220, 223, 230, 1);
      font-size: 0.833vw;
      font-weight: 500;
      color: rgba(90, 94, 102, 1);
      line-height: 1.94vw;
      cursor: pointer;
    }
    .group_popup_save {
      margin-left: 1.388vw;
      background: var(--mixtmt_mainColor6);
      color: rgba(255, 255, 255, 1);
      border: none;
      &:hover {
        background: var(--mixtmt_mainColor6);
      }
    }
    .group_popup_cancel {
      &:hover {
        border: 1px solid var(--mixtmt_mainColor6);
      }
    }
    // 删除弹框样式
    .group_popup_delete_tit {
      font-size: 0.972vw;
      font-weight: 600;
      color: var(--mixtmt_greyColor2);
      line-height: 1.25vw;
      text-align: center;
    }
    .group_popup_delete_wraning {
      margin: 1.388vw 0;
      font-size: 0.972vw;
      font-weight: 600;
      color: var(--mixtmt_greyColor2);
      line-height: 1.667vw;
      text-align: center;
      span {
        color: var(--mixtmt_errColor);
      }
    }
  }
}
.mixtmt_pc {
  #marathon_videoSectionCameraIndex {
    .add_item {
      cursor: pointer;
      &:hover {
        border: 1px solid var(--mixtmt_mainColor6);
      }
    }
    .dataList {
      .dataList_item {
        .item_btns {
          .btn {
            cursor: pointer;
            &:hover {
              background: var(--mixtmt_mainColor6);
              border: 1px solid var(--mixtmt_mainColor6);
              color: var(--mixtmt_whiteColor);
            }
          }
        }
      }
    }
  }
}
</style>
